export const color = {
  primary: "#4FB7D0",
  secondary: "#00A7D9",
  primaryBg: "#EAFDFF",
  secondaryBg: "#E6F4F1",
};
